// extracted by mini-css-extract-plugin
export default {"verticalPanels":"verticalPanels-gKyWwOGS","verticalPanel":"verticalPanel-ZTfbdodE"};